module.exports = __webpack_public_path__ + "img/lesson7.1a7d2a00.png";